export default from './Faqs';



// WEBPACK FOOTER //
// ./src/components/Faqs/index.js